/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StoreItemDetailResponse } from '../model/storeitemdetailresponse';
import { StoreItemRequest } from '../model/storeitemrequest';
import { StoreItemFileUpload } from '../model/storeitemfileupload';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { FileUploadStatus } from '../model/fileuploadstatus';

@Injectable()
export class StoreItemDetailService {

    constructor(public http: HttpClient) {
    }

    // Get call to fetch store item details
    public getStoreItemDetail(storeItemId: number) {
        return this.http.get<StoreItemDetailResponse>(CommonConstants.SERVICE_VERSION_PATH_V1
             + '/customer/stores/storeitems/' + storeItemId);
    }

    // Post call for to update user profile
    public createRequest( storeItemRequest: StoreItemRequest, storeItemId: number) {
        return this.http
            .post<number>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/stores/storeitems/' + storeItemId + '/request',
                storeItemRequest
            );
    }

    public uploadAttachments(storeItemFileUpload: StoreItemFileUpload) {
    const formData: FormData = new FormData();
      for (let i = 0; i < storeItemFileUpload.files.length; i++) {
       formData.append('uploadFile', storeItemFileUpload.files[i], storeItemFileUpload.files[i].name);
       }
        return this.http.post<FileUploadStatus>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/file/upload/' + storeItemFileUpload.requestId
         , formData);
    }
}
